import tw, { styled, css, theme } from 'twin.macro';

export const StyledDateNavigationWrapper = styled.div(() => [
  tw`py-8 px-4 h-auto flex justify-between items-center max-w-full`,
  css`
    min-width: ${theme('maxWidth.xs')};
  `
]);

export const StyledSelectMonthYearWrapper = styled.div(() => [
  tw`font-normal flex flex-auto justify-center items-center`
]);

export const StyledMonthSelectWrapper = styled.div(() => [tw`flex-1 mx-4 max-w-full`]);
export const StyledYearSelectWrapper = styled.div(() => [tw`mx-4 max-w-full`]);

export const StyledDateRangePicker = styled.div.attrs(() => ({}))(() => [
  tw`flex justify-center content-center pt-8 pb-8 `,

  css`
    .rdrDay {
      .rdrDayNumber span {
        ${tw`  text-black opacity-85 relative z-1  `}
      }

      &:not(.rdrDayPassive) .rdrInRange,
      .rdrEndEdge,
      .rdrStartEdge {
        ~ .rdrDayNumber span {
          ${tw`  text-white  `}
        }
      }

      .rdrInRange,
      .rdrEndEdge,
      .rdrStartEdge {
        ${tw`    bg-blue-darken-10 border-transparent `}
      }

      .rdrDayEndPreview {
        ${tw`mr-4 `}
      }

      .rdrDayStartPreview {
        ${tw`ml-4 `}
      }

      .rdrDayStartPreview,
      .rdrDayInPreview,
      .rdrDayEndPreview {
        ${tw`  bg-silver-lighten-10 border-none border-t border-blue-base mt-2 mb-2`},
      }

      &.rdrDayHovered:not(.rdrDayPassive) {
        ${tw` block`}
        .rdrInRange, .rdrEndEdge, .rdrStartEdge {
          ~ .rdrDayNumber {
            span {
              ${tw` text-black`}
              &:after {
                ${tw`  bg-blue-base `}
              }
            }
            &:after {
              ${tw` border-none bg-blue-base mt-2 mb-2 `}
            }
          }
        }
      }
    }

    .rdrStartEdge {
      ${tw` border-l  `}
    }
    .rdrEndEdge {
      ${tw` border-r  `}
    }
    .rdrDayPassive {
      .rdrDayNumber span {
        ${tw`  text-black text-opacity-45  `}
      }
    }
    .rdrDayPassive {
      .rdrInRange,
      .rdrEndEdge,
      .rdrStartEdge {
        ~ .rdrDayNumber span {
          ${tw`  text-white text-opacity-65  `}
        }
      }
    }

    .rdrDayToday .rdrDayNumber {
      span {
        ${tw`  font-bold`}
        &:after {
          ${tw`  bg-blue-base mb-8 bottom-0 `}
        }
      }
    }
    .rdrDayToday .rdrInRange ~ .rdrDayNumber span:after,
    .rdrDayToday .rdrStartEdge ~ .rdrDayNumber span:after,
    .rdrDayToday .rdrEndEdge ~ .rdrDayNumber span:after,
    .rdrDayToday .rdrSelected ~ .rdrDayNumber span:after {
      ${tw`  bg-white`},
    }

    .rdrWeekDay,
    .rdrMonthName {
      ${tw` text-black text-opacity-45`}
    }

    .rdrNextPrevButton {
      ${tw`bg-transparent`}
      &:hover {
        ${tw`bg-silver-lighten-10`}
      }
    }

    .rdrWeekDay,
    .rdrMonthName {
      ${tw`uppercase`}
    }

    .rdrMonth {
      ${tw`pb-4 max-w-full mx-auto`}
    }

    .rdrMonthName {
      ${tw`px-8 py-8`}
    }

    .rdrSelected,
    .rdrInRange,
    .rdrStartEdge,
    .rdrEndEdge {
      ${tw`mt-4 top-0 bottom-0 mb-4`}
    }
  `
]);

export default StyledDateRangePicker;
